"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
let TranslationKey = exports.TranslationKey = /*#__PURE__*/function (TranslationKey) {
  TranslationKey["activate"] = "activate";
  TranslationKey["add"] = "add";
  TranslationKey["added"] = "added";
  TranslationKey["addedToYourOrderAtACost"] = "addedToYourOrderAtACost";
  TranslationKey["addedToYourOrderWithout"] = "addedToYourOrderWithout";
  TranslationKey["bpCount"] = "bpCount";
  TranslationKey["bvCount"] = "bvCount";
  TranslationKey["cancel"] = "cancel";
  TranslationKey["cataloguePrice"] = "cataloguePrice";
  TranslationKey["checkoutOffers"] = "checkoutOffers";
  TranslationKey["clearBasket"] = "clearBasket";
  TranslationKey["closeList"] = "closeList";
  TranslationKey["closeSetComponents"] = "closeSetComponents";
  TranslationKey["combineYourOrder"] = "combineYourOrder";
  TranslationKey["continueShopping"] = "continueShopping";
  TranslationKey["customerOrders"] = "customerOrders";
  TranslationKey["cycle"] = "cycle";
  TranslationKey["delete"] = "delete";
  TranslationKey["doYouWantToClearYourBasket"] = "doYouWantToClearYourBasket";
  TranslationKey["earn"] = "earn";
  TranslationKey["emptyBag"] = "emptyBag";
  TranslationKey["enjoyFreeShipping"] = "enjoyFreeShipping";
  TranslationKey["everyXweeks"] = "everyXweeks";
  TranslationKey["expiringInFewDays"] = "expiringInFewDays";
  TranslationKey["favorites"] = "favorites";
  TranslationKey["favourite"] = "favourite";
  TranslationKey["goToRewardsShop"] = "goToRewardsShop";
  TranslationKey["itemsAddedByOriflameWillBeKept"] = "itemsAddedByOriflameWillBeKept";
  TranslationKey["lookingPrettyEmptyInYourBag"] = "lookingPrettyEmptyInYourBag";
  TranslationKey["manageSubscriptions"] = "manageSubscriptions";
  TranslationKey["more"] = "more";
  TranslationKey["myBag"] = "myBag";
  TranslationKey["newEdition"] = "newEdition";
  TranslationKey["newEditionAvailable"] = "newEditionAvailable";
  TranslationKey["nextShipment"] = "nextShipment";
  TranslationKey["no"] = "no";
  TranslationKey["none"] = "none";
  TranslationKey["notify"] = "notify";
  TranslationKey["notifyMe"] = "notifyMe";
  TranslationKey["openList"] = "openList";
  TranslationKey["originalProduct"] = "originalProduct";
  TranslationKey["popular"] = "popular";
  TranslationKey["postpone"] = "postpone";
  TranslationKey["price"] = "price";
  TranslationKey["promotionCode"] = "promotionCode";
  TranslationKey["qty"] = "qty";
  TranslationKey["quantity"] = "quantity";
  TranslationKey["recentlyViewed"] = "recentlyViewed";
  TranslationKey["regularPrice"] = "regularPrice";
  TranslationKey["related"] = "related";
  TranslationKey["replace"] = "replace";
  TranslationKey["replaced"] = "replaced";
  TranslationKey["reserve"] = "reserve";
  TranslationKey["reserved"] = "reserved";
  TranslationKey["samples"] = "samples";
  TranslationKey["shippingOffer"] = "shippingOffer";
  TranslationKey["showSetComponents"] = "showSetComponents";
  TranslationKey["step"] = "step";
  TranslationKey["subscribe"] = "subscribe";
  TranslationKey["subscribed"] = "subscribed";
  TranslationKey["subscriptions"] = "subscriptions";
  TranslationKey["superdeal"] = "superdeal";
  TranslationKey["total"] = "total";
  TranslationKey["unitPrice"] = "unitPrice";
  TranslationKey["unreserve"] = "unreserve";
  TranslationKey["voucherCodeIsRequired"] = "voucherCodeIsRequired";
  TranslationKey["voucherCodeIsTooLong"] = "voucherCodeIsTooLong";
  TranslationKey["whatsInside"] = "whatsInside";
  TranslationKey["yes"] = "yes";
  TranslationKey["youSave"] = "youSave";
  TranslationKey["youStillHave0pointsLeft"] = "youStillHave0pointsLeft";
  return TranslationKey;
}({});